import { Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import PlanModal from "../Modals/PlanModal";
import dataTableData from "../data/plan";
import DataTable from "../DataTable";
import { Add, TipsAndUpdates } from "@mui/icons-material";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";

function Plan({ superadmin_data, data, processing, handleRefresh, main_data }) {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();

  const [suggestion, setSuggestion] = useState(false);

  const handleSubmit = async (category) => {
    const payload = {
      type: "agency",
      name: category.name,
      score: category.score,
      color: category.color,
      allowed_hours: category.allowed_hours,
      agency_id: agency._id,
    };
    const { response } = await AppService.health_plan.create({
      payload,
      toaster: true,
    });
    if (response) {
      handleRefresh();
    }
  };
  return (
    <SoftBox>
      <Grid container rowSpacing={3}>
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
          {/* <SoftBox mr={1}>
            <TipsAndUpdates sx={{ cursor: "pointer" }} onClick={() => setSuggestion(!suggestion)} />
          </SoftBox> */}
          <PlanModal handleRefresh={handleRefresh} />
        </Grid>
        <Grid>
          <Stack direction="row" spacing={1}>
            {superadmin_data?.filter((item) => !main_data?.some((main_data) => main_data?.name === item?.name))?.map((category) => (
              <Chip
                key={category._id}
                label={category?.name}
                icon={<Add />}
                onClick={() => handleSubmit(category)}
                sx={{ cursor: "pointer" }}
                variant="outlined"
              />
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <DataTable table={data} canSearch />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default Plan;
